import FilledCircleIcon from '@components/v2/icons/FilledCircle';
import Icon from '@components/v2/ui/Icon/Icon';
import { Box } from '@mui/material';
import { HighlightsTestIds } from '../../../utils/testIds/Highlights.testIds';
import { HIGHLIGHT_UNREAD_DOT_SIZE } from '../highlights.constants';

const INDICATOR_STYLES = {
  color: 'primary.main',
  '& svg': {
    fontSize: HIGHLIGHT_UNREAD_DOT_SIZE,
    height: HIGHLIGHT_UNREAD_DOT_SIZE,
    width: HIGHLIGHT_UNREAD_DOT_SIZE,
  },
} as const;

const HighlightUnreadIndicator = () => (
  <Box test-id={HighlightsTestIds.UNREAD_INDICATOR} sx={INDICATOR_STYLES}>
    <Icon icon={FilledCircleIcon} size="xs" />
  </Box>
);

export default HighlightUnreadIndicator;
